import {useEffect, useRef, useState} from "react";
import {Button, CircularProgress} from "@mui/material";
import {AddAPhoto, ArrowUpward, Delete} from "@mui/icons-material";
import Box from "@mui/material/Box";
import SlideFileCustom from "../../../../../../../material/file/SlideFileCustom";
import FileData from "../../../../../../../material/file/FileData";
import isNull from "../../../../../../../mixin/isNull";
import useHelper from "../../../../../../../use/useHelper";
import PopperWrapper from "../../../../../../../material/popper/PopperWrapper";
import useEventDispatcher from "../../../../../../../use/useEventDispatcher";
import parameter from "../../../../../../../enum/parameter";
import Compressor from 'compressorjs';

export default function ({onChange}) {
    const eventDispatcher = useEventDispatcher();
    const helper = useHelper();
    const pictureInput = useRef();
    const uploadButtonRef = useRef();
    const [pictures, setPictures] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        eventDispatcher.launcher("first-emergency-picture");
    }, []);

    useEffect(() => {
        onChange(pictures);
    }, [pictures.length]);

    const handleAddPictureClicked = () => pictureInput.current.click();

    const handleUpload = async e => {
        setLoading(true);


        if (e.target.files.length === 0) {
            setLoading(false);
            return;
        }

        let initialCount = pictures.length;

        for (let i = 0; i < e.target.files.length; i++) {
            const file = e.target.files[i];

            if (file.type.startsWith("image")) {
                const options = {
                    quality: 0.3,

                    // Compression success callback
                    success: async result => {
                        const res = await helper.inputFileToRequestFile(result);

                        setPictures((prevState) => ([...prevState, res]));
                        setLoading(false);
                    },
                    error: () => {
                        setLoading(false);
                    }
                };

                try {
                    new Compressor(file, options);
                } catch (e) {
                    const res = await helper.inputFileToRequestFile(file);

                    setPictures((prevState) => ([...prevState, res]));
                    setLoading(false);
                }
            } else {
                const reader = new FileReader();

                reader.onload = ((f) => (e) => {
                    let contentType = file.type;
                    let content = e.target.result.replace("data:" + contentType + ";base64,", "");

                    setPictures((prevState) => ([...prevState, {"content": content, "content-type": contentType}]));
                    setLoading(false);
                })(file);
                reader.readAsDataURL(file);
            }

            initialCount++;
        }

        if (initialCount === 1) {
            eventDispatcher.launcher("more-than-one-emergency-picture");
        }
    }

    const handleDelete = () => {
        setPictures([...pictures.filter((pb, i) => i != currentIndex)]);
    }

    const getFile = async index => {
        const file = pictures[index];

        return new FileData("picture", file.content, file["content-type"]);
    }

    return (
        <>
            <Box display="flex" justifyContent={"center"}>
                <PopperWrapper
                    elementRef={uploadButtonRef}
                    placement={"bottom"}
                    content={"Prenez votre deuxième photo"}
                    triggeringEvent={"more-than-one-emergency-picture"}
                    autoCloseAfter={parameter.POPUP_TIME}
                    displayCloseButton={false}
                    contentColor={parameter.POPUP_COLOR}
                    icon={<ArrowUpward color={parameter.POPUP_COLOR}/>}
                />
                <PopperWrapper
                    elementRef={uploadButtonRef}
                    placement={"bottom"}
                    content={"Prenez votre première photo"}
                    triggeringEvent={"first-emergency-picture"}
                    autoCloseAfter={parameter.POPUP_TIME}
                    displayCloseButton={false}
                    contentColor={parameter.POPUP_COLOR}
                    icon={<ArrowUpward color={parameter.POPUP_COLOR}/>}
                />
                <Button
                    startIcon={loading ? <CircularProgress size={20} color={"inherit"}/> : <AddAPhoto/>}
                    variant={"contained"}
                    sx={{width: "80%"}}
                    onClick={handleAddPictureClicked}
                    disabled={loading}
                    ref={uploadButtonRef}
                    data-test="button-picture"
                >
                    {
                        !loading
                            ? "Prendre une photo"
                            : "Compression de l'image"
                    }
                </Button>
                <input
                    ref={pictureInput}
                    style={{display: "none"}}
                    type={"file"}
                    accept="image/*"
                    onChange={handleUpload}
                    data-test="input-file"
                    multiple
                />

            </Box>
            <Box mt={5}>
                {
                    !isNull(currentIndex)
                        ? (
                            <Box display="flex" justifyContent="end" mb={3} mr={2}>
                                <Button startIcon={<Delete/>} variant={"contained"} color={"error"} onClick={handleDelete}>
                                    Supprimer
                                </Button>
                            </Box>
                        )
                        : null
                }

                <SlideFileCustom
                    key={pictures.length}
                    ids={pictures.map((pb, i) => i)}
                    getFile={getFile}
                    startAtIndex={pictures.length - 1}
                    disableDownload={true}
                    onChange={setCurrentIndex}
                />
            </Box>
        </>
    )
}